// import styled from 'styled-components';
import styled from "@emotion/styled";


type PostBasicStyleTypes = {
	active?: boolean;
  noPad?: boolean;
  isMobile?: boolean;
};

export const PostBasicStyle = styled.div<PostBasicStyleTypes>`
  line-height: 1.7;
  font-size: ${(props: any) => props.isMobile ? props.theme.fontSizes.lg : props.theme.fontSizes.md};
  padding: ${(props: any) => props.noPad ? 0 : props.isMobile ? '0 0' : "0 60px"};

  p {
    font-size: 16px;
    margin-bottom: 20px;
  }

  a {
    color: ${(props: any) => props.theme.colors.b.dgr};
    &:hover {
      color: ${(props: any) => props.theme.colors.b.gr};
      text-decoration: underline;
    }
  }

  img {
    max-width: 100%;
    height: auto;
    margin-bottom: 12px;

    &.aligncenter {
      margin: 0 auto;
    }
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: 600;
  }

  h1 {
    font-size: 40px;
  }

  h2 {
    font-size: 32px;
  }

  h3 {
    font-size: 24px;
  }

  h4 {
    font-size: 20px;
  }

  h5 {
    font-size: 16px;
  }

  ul {
    margin-left: 20px;
    li {
      list-style: disc;
    }
  }

  ol {
    margin-left: 20px;
    li {
      list-style: decimal;
    }
  }

  img {
    display: inline-block;
  }

  table {
    width: 100%!important;
    border-top: 2px solid ${(props: any) => props.theme.colors.b.gr};

    td, th {
      border: 1px solid #d2d2d2;
      padding: 4px;
    }

    th {
      font-weight: bold;
    }
  }

  img {
    &.aligncenter {
      display: block;
      margin: 0 auto;
    }
  }

`;

export const PostNewsletterStyle = styled.div`
  max-width: 640px;
  margin: 0 auto;

  .stb-left-cell,
  .stb-right-cell {
    display: inline-block;
  }
`;
